import { computed } from 'vue';
import type { ImageSource } from '@record-fill';
import { useBranchLogo } from '@/entities/Branch';

export function useImageDisplay(getSource: () => ImageSource) {
  const { currentLogoUrl, handleLogoError, isBranchLogoUrl } = useBranchLogo();

  const displayUrl = computed(() => {
    const source = getSource();
    return source.kind === 'url' ? source.url : currentLogoUrl.value;
  });

  // A failed branch logo falls back to the default one; a failed picture of the matrix is left
  // alone, since nothing could replace it. A saved URL can still point at a branch logo stream.
  function handleImageError(): void {
    if (getSource().kind === 'branch-logo' || isBranchLogoUrl(displayUrl.value)) handleLogoError();
  }

  return { displayUrl, handleImageError };
}
